import { AppShell } from "../components/layout/AppShell";
import { DataTable, type Column } from "../components/ui/DataTable";
import { Badge } from "../components/ui/Primitives";
import { usePagedList } from "../hooks/usePagedList";
import type { AuditLogEntry } from "../api/types";

function actionTone(action: string): "success" | "danger" | "warn" | "gold" | "neutral" {
  if (action.includes("ban") || action.includes("delete") || action.includes("revoke") || action.includes("reject")) return "danger";
  if (action.includes("approve") || action.includes("grant") || action.includes("verify")) return "success";
  if (action.includes("login") || action.includes("logout")) return "neutral";
  return "gold";
}

export function AuditLogPage() {
  const { rows, isLoading, error, page, setPage, hasNextPage, reload } = usePagedList<AuditLogEntry>("/admin/audit-log");

  const columns: Column<AuditLogEntry>[] = [
    { header: "Admin", render: (row) => <span className="font-medium">{row.admin_email}</span> },
    { header: "Action", render: (row) => <Badge tone={actionTone(row.action)}>{row.action}</Badge> },
    {
      header: "Target",
      render: (row) => (row.target_type ? <span className="text-xs text-ink-muted">{row.target_type} #{row.target_id}</span> : "—"),
    },
    {
      header: "Details",
      render: (row) => <span className="max-w-xs truncate text-xs text-ink-faint">{row.details ? JSON.stringify(row.details) : "—"}</span>,
    },
    { header: "IP", render: (row) => <span className="text-xs text-ink-faint">{row.ip_address ?? "—"}</span> },
    { header: "When", render: (row) => new Date(row.created_at).toLocaleString() },
  ];

  return (
    <AppShell title="Audit Log">
      <p className="mb-4 text-xs text-ink-faint">
        Every sensitive action taken anywhere in this panel — read-only, append-only, restricted to super_admin.
      </p>
      <DataTable
        columns={columns}
        rows={rows}
        keyField={(r) => r.id}
        isLoading={isLoading}
        error={error}
        onRetry={reload}
        emptyTitle="No activity recorded yet"
        pagination={{ page, pageSize: 20, hasNextPage, onPageChange: setPage }}
      />
    </AppShell>
  );
}
